export default __webpack_public_path__ + "9188048a2f650954eb262201eae42c28.png";